import * as y from 'yup'

export const loginSchema = y.object({
    email: y.string().email().required(),
    password: y.string().required().min(6),
})
